/* ChicChac — product page enhancement (founder change-set)
   - "Add to Wishlist" as a proper labelled button (icon + text), toggles state.
     Shares the localStorage wishlist used by the product cards (key cc_wishlist).
   - Pincode delivery check near add-to-cart → client-side estimate stub.
     Real serviceability = Shiprocket API (needs account) — see
     docs/launch/shiprocket-setup-guide.md.
   No external dependencies. */
(function () {
  'use strict';
  var WKEY = 'cc_wishlist';
  function wl() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function saveWl(a) {
    try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {}
    /* keep the header wishlist count (cc-wishlist.js) in sync */
    try { document.dispatchEvent(new CustomEvent('cc:wishlist', { bubbles: true })); } catch (e) {}
  }

  /* Outline heart — see the note in cc-wishlist.js. Fills only when saved. */
  var HEART = '<svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20.3 4.7 13a4.7 4.7 0 0 1 6.6-6.6l.7.7.7-.7A4.7 4.7 0 1 1 19.3 13z"/></svg>';
  var TRUCK = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/></svg>';

  function handle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function buildWishlist(anchor, h) {
    if (document.querySelector('.cc-pdp-wishlist')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cc-pdp-wishlist';
    function render() {
      var on = wl().indexOf(h) > -1;
      btn.classList.toggle('is-active', on);
      btn.innerHTML = HEART + '<span>' + (on ? 'In Wishlist' : 'Add to Wishlist') + '</span>';
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var a = wl(), i = a.indexOf(h);
      if (i > -1) a.splice(i, 1); else a.push(h);
      saveWl(a); render();
    });
    render();
    anchor.parentNode.insertBefore(btn, anchor.nextSibling);
    return btn;
  }

  /* Pincode delivery check (A6-004 remediation, founder decision 2026-08-16:
     "implement logic somehow"). This used to be a hardcoded stub — any six
     digits, real or not, returned the same "3–7 days · COD available" line,
     which contradicted the published Shipping Policy (5–7 working days from
     order confirmation) and asserted COD availability the store has no way
     to know per pincode.

     Real Shiprocket serviceability can't be called from here — it needs a
     key, and there's no app backend/app proxy on this store to hide one
     behind. So this does genuine OFFLINE structural validation instead:
     window.CC_PINCODES (assets/cc-pincodes.js) is a prefix table built from
     real Indian PIN allocation (digit 1 is the postal region, digits 1–3
     the sorting district). A PIN that can't structurally exist is rejected;
     a PIN that can, gets its state named back and the same delivery window
     the Shipping Policy quotes — not a COD promise this store can't back. */
  function buildPincode(anchor) {
    if (document.querySelector('.cc-pincode')) return;
    var wrap = document.createElement('div');
    wrap.className = 'cc-pincode';
    wrap.innerHTML =
      '<div class="cc-pincode__label">' + TRUCK + '<span>Check delivery time</span></div>' +
      '<form class="cc-pincode__row" novalidate>' +
        '<label for="cc-pincode-input" class="visually-hidden">Delivery pincode</label>' +
        '<input type="text" inputmode="numeric" maxlength="6" pattern="[0-9]{6}" ' +
        'id="cc-pincode-input" class="cc-pincode__input" placeholder="Enter 6-digit pincode">' +
        '<button type="submit" class="cc-pincode__btn">Check</button>' +
      '</form>' +
      '<p class="cc-pincode__out" role="status" aria-live="polite"></p>';
    var form = wrap.querySelector('form');
    var input = wrap.querySelector('input');
    var out = wrap.querySelector('.cc-pincode__out');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var pin = (input.value || '').replace(/\D/g, '');
      if (pin.length !== 6) { out.textContent = 'Please enter a valid 6-digit pincode.'; out.className = 'cc-pincode__out is-error'; return; }
      /* Graceful degradation: if cc-pincodes.js failed to load (network
         blip, ad blocker, etc.), don't break the PDP — fall back to a
         format-only check with an honest, non-committal message rather
         than a fabricated ETA. */
      if (!window.CC_PINCODES || typeof window.CC_PINCODES.lookup !== 'function') {
        out.textContent = 'We couldn’t verify that pincode right now — delivery to serviceable Indian addresses takes 5–7 working days from order confirmation, per our Shipping Policy.';
        out.className = 'cc-pincode__out is-ok';
        return;
      }
      var state = window.CC_PINCODES.lookup(pin);
      if (!state) {
        out.textContent = 'That doesn’t look like a valid Indian pincode — please double-check the 6 digits.';
        out.className = 'cc-pincode__out is-error';
        return;
      }
      out.innerHTML = 'Delivers to <strong>' + state + '</strong> (' + pin + ') in <strong>5–7 working days</strong> from order confirmation, per our Shipping Policy.';
      out.className = 'cc-pincode__out is-ok';
    });
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
  }

  /* ------------------------------------------------------------------
     Description rework (founder change-set v2):
       "Make this section more interesting / Make the style tip more
        eyecatching / Add badges in the features section /
        Care needs to be Care Instructions"

     The catalogue body_html is a flat run of <p>/<ul> pairs:
       P intro · P "Style tip:" · P "Features:" + UL · P "Care Instructions:" + UL
     We tag those nodes so the CSS can turn the style tip into a callout and
     the features list into badge pills. Purely additive — if the copy shape
     ever changes, the description still renders as plain rich text.
     ------------------------------------------------------------------ */
  /* Feature name → [icon, caption]. The catalogue ships the same four features
     on all 34 SKUs ("Premium anti-tarnish alloy", "Waterproof", "Lightweight",
     "Skin friendly"), but match on keywords rather than exact strings so a new
     feature line still lands on a sensible icon instead of breaking the row. */
  var FEATURE_ICONS = [
    [/tarnish/i,
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 3l7 3v5c0 4.4-3 8.3-7 10-4-1.7-7-5.6-7-10V6l7-3z"/><path d="M9 12l2 2 4-4"/></svg>',
      'Designed to retain its brilliance over time'],
    [/water|swim|proof/i,
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 3s6 6.6 6 10.5A6 6 0 0 1 6 13.5C6 9.6 12 3 12 3z"/></svg>',
      'Splash and sweat safe for daily wear'],
    [/light\s*weight|lightweight/i,
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M20 4C10 4 4 10 4 20c8 0 16-6 16-16z"/><path d="M4 20L14 10"/></svg>',
      'Light enough to forget you have it on'],
    [/skin|hypo|friendly/i,
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 20s-6.5-4.2-8.5-8A5 5 0 0 1 12 6a5 5 0 0 1 8.5 6c-2 3.8-8.5 8-8.5 8z"/></svg>',
      'Gentle on skin, crafted for comfort']
  ];
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  /* Founder change-set v4: the bulb becomes a ✨ sparkle. Drawn as a filled
     four-point star cluster rather than the emoji so it inherits the gold of
     the callout border instead of rendering in the platform's own colours. */
  var SPARKLE = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
    '<path d="M13 2.2l1.9 5.2 5.2 1.9-5.2 1.9-1.9 5.2-1.9-5.2-5.2-1.9 5.2-1.9z"/>' +
    '<path d="M5.6 14.2l.9 2.4 2.4.9-2.4.9-.9 2.4-.9-2.4-2.4-.9 2.4-.9z"/>' +
    '<path d="M18.6 15.4l.6 1.7 1.7.6-1.7.6-.6 1.7-.6-1.7-1.7-.6 1.7-.6z"/></svg>';

  /* ------------------------------------------------------------------
     Styling-tip card (founder change-set v4b — reference artwork supplied).
     Layout: violet disc holding a gold "styled hand" mark, a hairline rule,
     then the heading and the tip copy. (The "Perfect for:" chip row this card
     carried in v4b was removed in v5.)
     ------------------------------------------------------------------ */
  /* Founder: "change the style tip icon to this emoji ✨". A real emoji, not a
     drawn mark — so it goes in as text and the platform renders its own colour
     glyph. `color` therefore does nothing here; the disc sizes it with
     font-size instead of the svg width/height the previous mark used. */
  var TIP_EMOJI = '✨';

  /* Founder change-set v5: "Remove 'perfect for …..' section from card". The
     occasion-chip row that v4b added below the tip copy is gone; the card is
     now disc + heading + copy only. The Match-Your-Mood tags it read still
     drive collections and the mood tiles — nothing else depended on this map. */

  function buildStyleTip(node) {
    /* The catalogue node is a flat <p>: "<strong>Style tip:</strong> copy…".
       Lift the copy out before rebuilding so the text is never re-parsed as
       HTML — it is customer-visible catalogue data, not markup. */
    var strong = node.querySelector('strong, b');
    if (strong) strong.remove();
    var copy = (node.textContent || '').replace(/^\s*[:\-–—]\s*/, '').trim();

    node.classList.add('cc-styletip');
    node.textContent = '';

    var disc = document.createElement('span');
    disc.className = 'cc-styletip__disc';
    disc.setAttribute('role', 'img');
    disc.setAttribute('aria-label', 'Styling tip');
    disc.textContent = TIP_EMOJI;

    var body = document.createElement('span');
    body.className = 'cc-styletip__body';

    var head = document.createElement('span');
    head.className = 'cc-styletip__label';
    head.textContent = "Stylist's Tip";
    var spark = document.createElement('span');
    spark.className = 'cc-styletip__spark';
    spark.innerHTML = SPARKLE;
    head.appendChild(spark);

    var text = document.createElement('span');
    text.className = 'cc-styletip__copy';
    text.textContent = copy;

    body.appendChild(head);
    body.appendChild(text);
    node.appendChild(disc);
    node.appendChild(body);
  }

  function featureFor(text) {
    for (var i = 0; i < FEATURE_ICONS.length; i++) {
      if (FEATURE_ICONS[i][0].test(text)) {
        return { icon: FEATURE_ICONS[i][1], note: FEATURE_ICONS[i][2] };
      }
    }
    return { icon: CHECK, note: '' };
  }

  /* Find the rte block holding the catalogue copy. */
  function descriptionRoot() {
    var blocks = Array.prototype.slice.call(document.querySelectorAll('rte-formatter, .rte'));
    return blocks.filter(function (b) {
      return /style tip|features\s*:/i.test(b.textContent || '');
    })[0];
  }

  function headingLabel(p) {
    var strong = p.querySelector('strong, b');
    return (strong ? strong.textContent : p.textContent || '').trim();
  }

  function enhanceDescription() {
    var root = descriptionRoot();
    if (!root || root.dataset.ccDesc === '1') return;
    root.dataset.ccDesc = '1';
    root.classList.add('cc-desc');

    var nodes = Array.prototype.slice.call(root.children);
    nodes.forEach(function (node, i) {
      if (node.tagName !== 'P') return;
      var label = headingLabel(node);
      var next = nodes[i + 1];

      if (/^style\s*tip|^stylist/i.test(label)) {
        buildStyleTip(node);
        return;
      }

      if (/^features|^why you/i.test(label)) {
        /* v4 founder: "Change Features heading to Why You'll love it".
           v4b: centred, with the gold rule-and-diamond ornament from the
           reference artwork. The rules are ::before/::after in CSS; the
           diamonds are real spans so they can carry their own colour. */
        var featLabel = node.querySelector('strong, b');
        if (featLabel) featLabel.textContent = "Why You'll love it";
        node.classList.add('cc-desc__head', 'cc-desc__head--ornate');
        if (next && next.tagName === 'UL') {
          next.classList.add('cc-featlist');
          Array.prototype.slice.call(next.children).forEach(function (li) {
            var txt = (li.textContent || '').trim();
            var f = featureFor(txt);
            /* Rebuilt rather than prepended: the v3 layout stacks icon → name →
               caption, so the bare text node has to become its own element.
               textContent (never innerHTML) for the catalogue copy. */
            li.textContent = '';
            var ic = document.createElement('span');
            ic.className = 'cc-featlist__icon';
            ic.innerHTML = f.icon;
            var name = document.createElement('span');
            name.className = 'cc-featlist__name';
            name.textContent = txt;
            li.appendChild(ic);
            li.appendChild(name);
            /* v4b: a gold rule with a centred diamond sits between the title
               and the caption in the reference artwork. */
            var rule = document.createElement('span');
            rule.className = 'cc-featlist__rule';
            rule.setAttribute('aria-hidden', 'true');
            li.appendChild(rule);
            if (f.note) {
              var note = document.createElement('span');
              note.className = 'cc-featlist__note';
              note.textContent = f.note;
              li.appendChild(note);
            }
          });
        }
        return;
      }

      if (/^care/i.test(label)) {
        /* founder: "Care needs to be Care Instructions". The catalogue data is
           being renamed too; this keeps older copy correct either way. */
        var strong = node.querySelector('strong, b');
        if (strong && /^care\s*:?\s*$/i.test(strong.textContent.trim())) {
          strong.textContent = 'Care Instructions:';
        }
        node.classList.add('cc-desc__head');
        if (next && next.tagName === 'UL') next.classList.add('cc-carelist');
      }
    });
  }

  function init() {
    enhanceDescription();
    var blocks = Array.prototype.slice.call(document.querySelectorAll('.buy-buttons-block'));
    var main = blocks.filter(function (b) { return !b.closest('.sticky-add-to-cart'); })[0] || blocks[0];
    if (!main) return;
    var h = handle();
    if (!h) return;
    var wishBtn = buildWishlist(main, h);
    buildPincode(wishBtn || main);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  /* Horizon renders the PDP from blocks and can swap the description in after
     DOMContentLoaded (and again on a variant change). Re-run the description
     pass when new nodes land; enhanceDescription() is guarded by a data flag
     so repeats are free. */
  new MutationObserver(function () { enhanceDescription(); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
